<template>
	<div class="multi-view">
		<component :is="component" v-bind="$attrs" :value="_value" @input="onInput" />
		<div class="tabs">
			<div :class="{ tab: true, active: tab.value == t.value }" v-for="(t, i) in tabs" :key="i" @click="tab = t">{{ t.label }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tab: {
					label: null,
					value: null
				}
			};
		},
		props: {
			component: {
				type: String,
				required: true
			},
			tabs: {
				type: Array,
				required: true
			},
			value: {
				type: Object,
				required: true
			}
		},
		computed: {
			_value() {
				return this.tab.value !== null ? this.value[this.tab.value] : '';
			}
		},
		methods: {
			normalize() {
				// Will keep old data
				this.$emit('input', {
					...this.tabs.reduce((acc, val) => { 
						acc[val.value] = '';
						return acc;
					}, {}),
					...this.value
				});

				console.log(this.value);
			},
			onInput(value) {
				var r = {...this.value, ...{}};
				r[this.tab.value] = value;

				console.log(r);

				this.$emit('input', r);
			}
		},
		created() {
			// Normalize value
			this.normalize();
		},
		mounted() {
			if (this.tabs.length > 0) {
				this.tab = this.tabs[0];
			}
		}
	}
</script>

<style lang="scss" scoped>
	.multi-view {
		& > .tabs {
			& > .tab {
				cursor: pointer;
				display: inline-block;
				margin-right: 10px;
				
				&.active {
					border-bottom: 1px solid #ff5723;
				}
			}
		}
	}
</style>